import { Badge } from "@chakra-ui/react";
import { claimStatusLabels } from "../columns";
import { ClaimStatus } from "../types";

const statusColors: Record<ClaimStatus, { bg: string; color: string }> = {
  reported: { bg: "#FFF7D6", color: "#E6AE22" },
  dismissed: { bg: "#F7F7F7", color: "#9F9DB0" },
  active: { bg: "#EDEBFF", color: "#7B61FA" },
  closed: { bg: "#E3FFE4", color: "#3CB18B" },
};

type Props = { status: ClaimStatus };

const StatusBadge = ({ status }: Props): JSX.Element => (
  <Badge
    bg={statusColors[status].bg}
    color={statusColors[status].color}
    size="md"
  >
    {claimStatusLabels[status]}
  </Badge>
);

export default StatusBadge;
